import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Route guard for the Parent Portal. Requires a real authenticated session
 * with the global "parent" role — no localStorage bypass. Unauthenticated
 * users are sent to login (preserving the return path); authenticated users
 * without the parent role are sent to the main dashboard.
 */
function ParentRoute({ children }) {
  const { accessToken, isInitialized, isParent } = useAuth();
  const location = useLocation();

  if (!isInitialized) {
    return null; // wait for auth hydration before deciding
  }

  if (!accessToken) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!isParent()) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default ParentRoute;
